<template>
  <div class="flex-c" style="margin-bottom: 30px">
    <div class="success-box">
      <div class="success-title">{{ i18n.success }}</div>
      <van-image
        width="7rem"
        fit="contain"
        :src="require('assets/imgs/device2.png')"
      />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    i18n() {
      return this.$t("borrowSuccess")
    }
  },
  methods: {}
}
</script>

<style  lang="less" scoped>
.success-box {
  text-align: center;
  margin-top: 80px;
}
.success-title {
  font-size: 56px;
  font-weight: bold;
  color: #000000;
}
</style>
